<cc-box class="import-details-wrapper" *ngIf="recordId">
  <div class="import-details-header" box header>
    <p class="import-details-title-text"><span>{{'EVENT_DETAILS.CONTACT_DETAILS' | translate}}</span></p>
<!--    <a-->
<!--      [routerLink]="['/projects', {id: 1, contactId: recordId, contactEventId: eventId, showContacts: true, '#': 'import-settings'}]"-->
<!--      class="import-details-title-link">{{'EVENT_DETAILS.CUSTOMIZATION' | translate}}</a>-->
  </div>

  <div class="box-content import-details-content" box content>
    <form [formGroup]="detailsForm"
          class="form-wrapper"
          (ngSubmit)="saveChanges()"
          ccScrollToFirstInvalidInput>
      <div class="import-details-row">
        <div class="import-details-input-wrapper">
          <label for="first-name">{{ 'FIRST_NAME' | translate }}</label>
          <input formControlName="firstName"
                 class="form-control"
                 [placeholder]="'FIRST_NAME' | translate"
                 id="first-name">
        </div>
        <div class="import-details-input-wrapper">
          <label for="last-name">{{ 'LAST_NAME' | translate }}</label>
          <input formControlName="lastName"
                 class="form-control"
                 [placeholder]="'LAST_NAME' | translate"
                 id="last-name">
        </div>
      </div>
      <div class="import-details-row">
        <label for="company">{{ 'COMPANY' | translate }}</label>
        <input formControlName="company"
               class="form-control"
               [placeholder]="'COMPANY' | translate"
               id="company">
      </div>

      <div class="import-details-row">
        <label for="email">{{ 'EMAIL' | translate }}</label>
        <input formControlName="email"
               class="form-control"
               [placeholder]="'EMAIL' | translate"
               id="email">
      </div>

      <div class="import-details-row">
        <label for="external-link">{{ 'EXTERNAL_LINK' | translate }}</label>

        <div class="link-wrapper">
          <input formControlName="externalLink"
                 class="form-control"
                 [placeholder]="'EXTERNAL_LINK' | translate"
                 id="external-link">
          <a *ngIf="hyperLink" [href]="hyperLink" target="_blank">
            <i class="material-icons">link</i>
          </a>
        </div>
        <span *ngIf="!isExternalLinkValid()" class="error-message">{{'RECORDS_LIST.ERROR.EXTERNAL_LINK' | translate}}</span>
      </div>
      <div class="import-details-row right-sided">
      <button class="btn channels-button info-full"
              id="save"
              [class.disabled]="!isExternalLinkValid() || loading"
              translate>SAVE_CHANGES
      </button>
      </div>
    </form>
  </div>
</cc-box>

